// Statuts Utilisateurs
export const STATUT_DETENUE = 1;
export const STATUT_EN_REPARATION_MODIFICATION = 2;
export const STATUT_EN_DEPOT_VENTE = 3;
export const STATUT_POUR_REPARATION_MODIFICATION = 4;
export const STATUT_POUR_DEPOT_VENTE = 5;
export const STATUT_TRANSFERT_EN_COURS = 6;
export const STATUT_A_RECEPTIONNER = 7;
export const STATUT_EN_ATTENTE_DE_VALIDATION = 8;
// le statut numéro 9 a été supprimé : STATUT_A_VALIDER = 9;
export const STATUT_PERDUE_OU_VOLEE = 10;
export const STATUT_FIN_DE_VIE = 11;
export const STATUT_EST_PERDUE_OU_VOLEE = 12;
export const STATUT_BROUILLON = 13;
export const STATUT_DETRUITE = 14;
export const STATUT_EN_ATTENTE_MISE_EN_STOCK = 15;
export const STATUT_A_VALIDER_MISE_EN_STOCK = 16;
export const STATUT_POUR_VENTE_ENTRE_PARTICULIERS = 17;
export const STATUT_EN_VENTE_ENTRE_PARTICULIERS = 18;
export const STATUT_SUPPRIMEE = 19;
export const STATUT_POUR_PRET = 20;
export const STATUT_EN_PRET = 21;
export const STATUT_DEMANDE_SUPPRESSION = 22;
